import { createClient } from '@supabase/supabase-js'

// 🔥 fallback seguro (esto evita pantalla en blanco)
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error("Faltan variables de entorno REACT_APP_SUPABASE_URL y REACT_APP_SUPABASE_ANON_KEY");
}

// Detect localStorage availability before passing it to Supabase.
// Safari Private Browsing throws SecurityError on any localStorage access.
// When unavailable, pass undefined so Supabase falls back to in-memory storage,
// keeping auth functional for the session without crashing on startup.
//
// Exported so auth flows can detect this condition and show appropriate UX
// (e.g. SetPassword warns the user if they're in private browsing mode).
export const hasLocalStorage = (() => {
  try {
    localStorage.setItem('__test', '1');
    localStorage.removeItem('__test');
    return true;
  } catch {
    return false;
  }
})();

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    // Explicit key so the offline guard in App.js can probe localStorage
    // with a stable, predictable name instead of the default sb-<ref>-auth-token.
    storageKey: 'keves-auth',
    storage: hasLocalStorage ? window.localStorage : undefined,
  },
});